var EHDI = EHDI || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.CropState = {
    SEED: 0,
    SMALL: 1,
    MEDIUM: 2,
    GROWN: 3,
    DEAD: 4
};

EHDI.components.Crop = function(){
    EHDI.aka.Container.call(this);
    var _this = this;
    
    this.cropState = Math.floor(Math.random() * 4);
    this.isSelected = false;
    this.isGlowing = false;
    this.canGlow = true;
    
    getAnimIndex = EHDI.components.Crop.getAnimationIndexByState;

    this.armature = EHDI.DBoneFactory.createArmature("Armature");
    this.animationSprite = this.armature.getDisplay();
    this.cropAnimList = this.armature.animation.animationList;
    this.cropAnimDataList = this.armature.animation.animationDataList;
    this.armature.animation.gotoAndStop(this.cropAnimList[getAnimIndex(this.cropState)], this.cropAnimDataList[getAnimIndex(this.cropState)].duration * 0.001 - 0.001);
    this.animationSprite.position.set(this.animationSprite.width * 0.5, this.animationSprite.height * 0.5);
    this.addChild(this.animationSprite);

    this.effectarmature = EHDI.DBoneFactory.createArmature("combofx_armature");
    this.effectanimationSprite = this.effectarmature.getDisplay();
    this.effectAnimList = this.effectarmature.animation.animationList;
    this.effectAnimDataList = this.armature.animation.animationDataList;
    this.effectanimationSprite.scale.x = 0.5;
    this.effectanimationSprite.scale.y = 0.5;
    
    this.effectarmature.animation.gotoAndStop(this.effectAnimList[0], this.effectAnimDataList[0].duration * 0.001 - 0.001);
    this.effectanimationSprite.position.set(this.effectanimationSprite.width, this.effectanimationSprite.height);

    
    this.glow = new EHDI.components.GlowEffect(this.animationSprite.width);
    this.glow.position.set(this.animationSprite.width * 0.5, this.animationSprite.height * 0.5);
    

    var updateColorVal = function(play){
        if(play) _this.armature.animation.gotoAndPlay(_this.cropAnimList[getAnimIndex(_this.cropState)], -1, -1, 1);
        else _this.armature.animation.gotoAndStop(_this.cropAnimList[getAnimIndex(_this.cropState)], _this.cropAnimDataList[getAnimIndex(_this.cropState)].duration * 0.001 - 0.001);
    };

    var harvestComplete = function(e){
        _this.armature.removeEventListener(dragonBones.AnimationEvent.COMPLETE, _this.armature._listenerDict[0]);
        updateColorVal();
        EHDI.gameInstanceRef.harvestComplete();
    };

    
    var sparkleComplete =  function(e)
    {
        _this.effectarmature.removeEventListener(dragonBones.AnimationEvent.COMPLETE, _this.effectarmature._listenerDict[0]);
        _this.removeChild(this.effectanimationSprite);
    }

    this.sparkle = function()
    {
        
        this.effectarmature.addEventListener(dragonBones.AnimationEvent.COMPLETE, sparkleComplete);
        this.effectarmature.animation.gotoAndPlay(this.effectAnimList[0], 0,0,1);
        this.addChild(this.effectanimationSprite);
    }

    this.updateGrowth = function(play){
        if(this.cropState < EHDI.components.CropState.DEAD)
            {
            this.cropState++;                           
            EHDI.GAME.soundManager.playSFX("plant_grow", 0.25);
            }
        else if( this.cropState == EHDI.components.CropState.DEAD)
            this.cropState = EHDI.components.CropState.SEED;
        
        updateColorVal(play);
    };

    this.harvestCrop = function(){
        this.glowOff();
        if(this.cropState ==  EHDI.components.CropState.GROWN){
            this.cropState = EHDI.components.CropState.SEED;
            // EHDI.GAME.soundManager.playSFX("plant_harvest");
            this.armature.addEventListener(dragonBones.AnimationEvent.COMPLETE, harvestComplete);
            this.armature.animation.gotoAndPlay(this.cropAnimList[0], -1, -1, 1);
            return true;
        }
        return false;
    };
    
    this.glowOn = function()
    {
        if(!this.canGlow)
            return;

        this.glow.appear();
        this.addChild(this.glow);   
        this.isGlowing = true; 
    }

    this.glowOff = function()
    {
        if(!this.isGlowing)
            return;

        this.removeChild(this.glow);
        this.glow.disappear();
        this.glow.timeLineKill();
        this.isGlowing = false;
    }

    this.glowPause = function()
    {
        if(this.glow)
        this.glow.timeLinePause();
    }
    
    this.glowResume = function()
    {      
        if(this.glow)  
        this.glow.timeLineResume();
    }

    this.disableGlow = function()
    {
        this.canGlow = false;
        this.glowOff();
    }

    this.setSelected = function(sel){
        this.isSelected = sel;
        if(this.isSelected)
            {
                 this.armature.animation.gotoAndPlay(this.cropAnimList[6], -1, -1, 1);                 
                EHDI.GAME.soundManager.playSFX("plant_select");
            }
        else this.armature.animation.gotoAndStop(this.cropAnimList[getAnimIndex(this.cropState)], this.cropAnimDataList[getAnimIndex(this.cropState)].duration * 0.001 - 0.001);
    }

    this.shakeCrop = function(complete){
        EHDI.GAME.soundManager.playSFX("wrong_plant");
        this.tl = new TimelineMax({repeat: 4, yoyo: true, onComplete:shakeCropDone, onCompleteParams:[complete, this.x]});
        this.x -= 2.5;
        this.tl.to(this, 0.0625, {x: this.x + 5, ease: Power0.easeNone});
        this.tl.play();
    };

    var shakeCropDone = function(complete, origX){
        this.x = origX;
        complete();
    };

};

EHDI.components.Crop.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.components.Crop.prototype.destroy = function() {
    EHDI.DBoneFactory.destroyArmature(this.armature);
    this.armature = null;
    if(this.tl != null) this.tl.kill();
    this.tl = null;
    EHDI.aka.Container.prototype.destroy.apply(this, arguments);
    this.glowOff();
    
}

EHDI.components.Crop.getAnimationIndexByState = function(state){
    if(state == EHDI.components.CropState.SEED) return 5;
    else if(state == EHDI.components.CropState.SMALL) return 1;
    else if(state == EHDI.components.CropState.MEDIUM) return 2;
    else if(state == EHDI.components.CropState.GROWN) return 3;
    return 4;
}